import { getProductFormField } from '../utils';
import Component, { ProductFormInputProps } from './ProductFormInput';
import { injectIntl } from 'react-intl';

export default getProductFormField<ProductFormInputProps>(injectIntl(Component));
